import { useEffect } from 'react'

import create from 'zustand'
import {
  getDefaultZoom,
  cloneObject
} from '../../../shared/utils'
import shallow from 'zustand/shallow'

/**
 * Create state store for puzzles
 */
const [useViewerStore] = create((set) => ({
  active: null,
  autoRotate: false,
  rotation: [0, 0, 0],
  zoom: 0.02,
  resetState: null,
  reset: () => set((state) => state.resetState),
  setResetState: (resetState) => set({ resetState }),
  setActiveModel: (model) => {
    set({
      active: model,
      rotation: model.rotation,
      zoom: getDefaultZoom(model.zoomBounds),
      autoRotate: true,
      resetState: cloneObject({
        rotation: model.rotation,
        zoom: getDefaultZoom(model.zoomBounds),
        autoRotate: true
      })
    })
  },
  setRotation: (rotation) => set({ rotation }),
  setZoom: (zoom) => set({ zoom }),
  setAutoRotate: ({ autoRotate }) => set({ autoRotate }),
  toggleAutoRotate: () =>
    set((state) => ({ autoRotate: !state.autoRotate }))
}))

export const useViewerModel = (initialModel) => {
  const [model, set] = useViewerStore(
    (state) => [state.active, state.setActiveModel],
    shallow
  )
  useEffect(() => {
    typeof initialModel !== undefined && set(initialModel)
  }, [initialModel, set])
  return [model, set]
}

// rotation for current model
export const useViewerRotation = () =>
  useViewerStore(
    (state) => [state.rotation, state.setRotation],
    shallow
  )

export const useViewerZoom = (initialZoom) => {
  const [zoom, set] = useViewerStore(
    (state) => [state.zoom, state.setZoom],
    shallow
  )
  useEffect(() => {
    typeof initialZoom !== undefined && set(initialZoom)
  }, [initialZoom, set])
  return [zoom, set]
}

export const useViewerAutoRotate = () =>
  useViewerStore(
    (state) => [state.autoRotate, state.toggleAutoRotate],
    shallow
  )

export const useViewerReset = () =>
  useViewerStore((state) => state.reset)

export default useViewerStore
